module.exports = __webpack_public_path__ + "img/bell.335ea2e6.svg";